"use strict";
import { Fragment, jsx } from "react/jsx-runtime";
import { Component } from "react";
import { ErrorPage } from "../ErrorPage";
export class ModuleErrorBoundary extends Component {
  /**
   * Derives the state for the error boundary from the specified error.
   * @param error The error to derive state from.
   */
  static getDerivedStateFromError(error) {
    return { error };
  }
  /**
   * Called when the component catches an error.
   * @param error The error being caught.
   * @param errorInfo The error information.
   */
  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
  }
  /** Renders the component. */
  render() {
    const { children } = this.props;
    const { error } = this.state;
    if (error !== null) {
      return /* @__PURE__ */ jsx(ErrorPage, {});
    }
    return /* @__PURE__ */ jsx(Fragment, { children });
  }
  /**
   * Initializes a new instance of the ModuleErrorBoundary class.
   * @param props The component properties.
   */
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
}
